import { Component, OnInit, Input, NgZone, ChangeDetectorRef, Injector, NgModuleRef, Compiler, Renderer2, ElementRef, KeyValueDiffers, ViewChild } from '@angular/core';
import { RestProviderService } from '../../../services/rest-provider/rest-provider.service';
import { ActivatedRoute, Router } from '@angular/router';
import { SemBaseComponent } from '../../common/sem-base/sem-base.component';
import { RouteNavigationService } from '../../../services/dynamic-routes-loader/route-navigation.service';
import { MatDialog } from '@angular/material/dialog';
import { Location } from '@angular/common';
import { TranslationsProviderService } from 'src/app/services/translations-provider/translations-provider.service';
import { FileUploadService } from 'src/app/services/file-upload-service/file-upload.service';
import { Observable } from 'rxjs';
import { MetaModelService } from '../../../services/metamodel/metamodel-provider.service';
import { UserService } from '../../../services/user/user-provider.service';
import { SearchService } from '../../../services/search/search.service';
import { DynamicFieldsManagerService } from 'src/app/services/dynamic-fields/dynamic-fields-manager.service';
import { NgForm, FormBuilder } from '@angular/forms';
import { ActionsService } from 'src/app/services/actions-service/actions.service';
import { UtilityService } from 'src/app/services/utility/utility.service';
import { ParameterFormsService } from 'src/app/services/parameter-forms-service/parameter-forms.service';
import { FormService } from '../../../services/form-service/form.service';
import { NgxPhotoEditorService } from 'ngx-photo-editor';
import { HttpClient } from '@angular/common/http';
import { ClientAction, FileDataModel } from '../../../models/file-upload/file-data';
import { environment } from '../../../../environments/environment';
import { LocalStorageService } from '../../../services/local-storage-service/local-storage.service';



@Component({
    selector: 'app-sem-control',
    templateUrl: './sem-control.component.html',
    styleUrls: ['./sem-control.component.css'],
    standalone: false
})
export class SemControlComponent extends SemBaseComponent implements OnInit {

  //constructor(private _compiler: Compiler, private _injector: Injector, private _m: NgModuleRef<any>) { }
  constructor(
    public restProviderService: RestProviderService,
    public zone: NgZone,
    public changeDetection: ChangeDetectorRef,
    public _injector: Injector,
    public _m: NgModuleRef<any>,
    public _compiler: Compiler,
    public route: ActivatedRoute,
    public router: Router,
    public dialog: MatDialog,
    public renderer: Renderer2,
    public translationsService: TranslationsProviderService,
    public fileUploadService: FileUploadService,
    public metaModelService: MetaModelService,
    public userService: UserService,
    public searchService: SearchService,
    public control: ElementRef,
    public formBuilder: FormBuilder,
    public actionsService: ActionsService,
    public dfms: DynamicFieldsManagerService,
    public utility: UtilityService,
    public parameterFormService: ParameterFormsService,
    public formService: FormService,
    public photoEditorService: NgxPhotoEditorService,
    public anglarHttpClient: HttpClient,
    public angLocation: Location,
    public localStorageService: LocalStorageService) {

    super(_injector, router, route, dfms, utility, formService);
  }

  @Input() public title: string = "";
  @Input() model: any;
  @Input() fields: any;
  params: any;
  @Input() modelChangeNotifier: Observable<void>;
  @Input() form: NgForm;
  @Input() name: any;
  @Input() events: any;
  @Input() cssClass: any;
  @Input() isRequired: any;
  @Input() isReadOnly: any;
  @Input() condition: any;
  @Input() bindingProperty: string;
  @Input() showTooltip: any;
  @Input() tooltipTextMessage: string;
  @Input() readOnlyCondition: any;
  @Input() parentBindingProp: any;
  @Input() min: any;
  @Input() max: any;
  @Input() preJS: any;
  @Input() postJS: any;
  @Input() onValueChangeEval: any;
  @Input() placeholder: string = "";
  loading: boolean = false;

  @ViewChild('f', { read: NgForm, static: true }) mainViewForm: NgForm;

  ngOnInit() {
    this.route
      .queryParams
      .subscribe(params => {
        // Defaults to 0 if no query param provided.
        this.params = params;
      });

    this.isRequired = this.getAttribute('required');
  }

  mapItem(file: File, action: ClientAction, type: number = null, mediaId: any = null, category = 3) {
    let fileDataModel = new FileDataModel(null);
    fileDataModel.Name = file.name;
    fileDataModel.Action = action;
    fileDataModel.Size = file.size;
    fileDataModel.File = file;

    if (mediaId) {
      fileDataModel.Id = mediaId;
      fileDataModel.FileID = mediaId;
    }

    fileDataModel.Category = category;


    fileDataModel.FileOrder = this.fileUploadService.filesInfo.length + 1;

    return fileDataModel;
  }

  checkTranslation(value: string) {
    return this.translationsService.translate(value);
  }

  getAttribute(atribute: string) {
    return this.control.nativeElement.getAttribute(atribute);
  }

  checkPlaceholder(initialValue = "") {
    /*if (this.checkForDisabled(this.getAttribute('name'))) {
      this.placeholder = 'WebGalis_FillOutAuto';
    }*/

    if (initialValue.length > 0 && this.placeholder.length == 0) {
      this.placeholder = initialValue;
    }

    return this.translationsService.translate(this.placeholder);
  }

  // readOnlyCondition is configured either against the record model ("!model.LossEventState?.Id==2")
  // or against the control ("this.model.Id > 0", "this.checkIfInUserGroup(5)"). Evaluate it with `model`
  // in scope and `this` bound, the same way jsAddCondition is evaluated in the one-to-many container.
  // The compiled function is cached per expression (templates call this on every change detection).
  // A failing expression (record not loaded yet, typo) never throws into the template: it is logged
  // once per control and counts as "not read-only".
  private readOnlyConditionSource: string = null;
  private readOnlyConditionFn: Function = null;
  private readOnlyConditionWarned = false;
  evaluateReadOnlyCondition(): any {
    const source = typeof this.readOnlyCondition == "string" ? this.readOnlyCondition.trim() : "";
    if (source.length == 0) {
      return false;
    }
    try {
      if (this.readOnlyConditionSource !== source) {
        this.readOnlyConditionFn = new Function('model', 'return ' + source);
        this.readOnlyConditionSource = source;
      }
      return this.readOnlyConditionFn.call(this, this.model);
    } catch (e) {
      if (!this.readOnlyConditionWarned) {
        this.readOnlyConditionWarned = true;
        console.warn("readOnlyCondition could not be evaluated, treated as not read-only:", source, e);
      }
      return false;
    }
  }

  checkForDisabled(name: string) {

    if (typeof this.readOnlyCondition != "undefined" && this.readOnlyCondition) {
      if (this.readOnlyCondition.length > 0) {
        return this.evaluateReadOnlyCondition();
      }
    }

    /*if (typeof this.readOnlyCondition != "undefined" && this.readOnlyCondition) {
      this.readOnlyCondition = this.readOnlyCondition + " && this.dfms?.isFormReadOnly == true";
    }else{
      this.readOnlyCondition = "this.dfms?.isFormReadOnly == true";
    }*/


    if (this.isReadOnly) {
      return this.isReadOnly;
    }


    if (name != null) {

      for (var i = 0; i < this.dfms.manyToOneReadOnly.length; i++) {
        if (name.includes(this.dfms.manyToOneReadOnly[i])) {
          return true;
        }
      }

      if (name != null) {

        if (name.startsWith("model.")) {
          name = name.replace("model.", "");
        }
        if (name.startsWith("Title.")) {
          name = name.replace("Title.", "");
        }

        if (typeof this.parentBindingProp != "undefined" && this.parentBindingProp) {
          if (this.parentBindingProp != "Title") {

            if (this.parentBindingProp.startsWith("Title.")) {
              this.parentBindingProp = this.parentBindingProp.replace("Title.", "");
            }

            name = this.parentBindingProp + "." + name;
          }
        }

        for (var i = 0; i < this.dfms.metaModel.length; i++) {
          if (this.dfms.metaModel[i].W == 0 && this.dfms.metaModel[i].Path == name) {
            return true;
          }
        }

      }
    }

    /*let roCondition = "";

    if(this.dfms?.isFormReadOnly){
      roCondition = "dfms?.isFormReadOnly == true";
    }*/

  }

  getBindingPropertyName() {
    let name = this.getAttribute("name");
    if (name != null) {

      if (name.startsWith("model.")) {
        name = name.replace("model.", "");
      }
      if (name.startsWith("Title.")) {
        name = name.replace("Title.", "");
      }

      if (typeof this.parentBindingProp != "undefined" && this.parentBindingProp) {
        if (this.parentBindingProp != "Title") {

          if (this.parentBindingProp.startsWith("Title.")) {
            this.parentBindingProp = this.parentBindingProp.replace("Title.", "");
          }

          name = this.parentBindingProp + "." + name;
        }
      }

      return name;

    }
    return "";
  }

  getName() {
    try {
      // Only report errors if this specific control instance is required
      // (avoids false positives when duplicate-named fields share a form control)
      const hasRequired = this.isRequired
        || this.control.nativeElement.hasAttribute('required')
        || this.control.nativeElement.hasAttribute('data-semrequired');
      if (!hasRequired) return null;

      if (typeof this.getAttribute('name') != "undefined" && this.getAttribute('name') != null) {
        return eval("this.form.controls['" + this.getAttribute('name') + "'].errors");
      }
      else if (typeof this.getAttribute('ng-reflect-name') != "undefined" && this.getAttribute('ng-reflect-name') != null) {
        return eval("this.form.controls['" + this.getAttribute('ng-reflect-name') + "'].errors");
      }
    } catch (e) {
      return null;
    }

    return null;
  }

  click() {
    if (this.events) {
      let clickEvent = this.events[0];
      eval(clickEvent.PreJs);
      if (typeof (clickEvent.Action) != "undefined" && clickEvent.Action != null && clickEvent.Action != "") {
        this.actionsService.executeAction(clickEvent.Action, this.model, this.model, null, null, this, null);
      }
      eval(clickEvent.PostJs);

    }
  }

  checkIfInArray(prop: [], id: any) {
    return prop.some(el => el["Id"] === id);
  }

  checkIfInUserGroup(id: any) {
    return this.userService.checkIfInUserGroup(id);
  }

  isRestrictedByGroup(key: string): boolean {
    const settings = (environment as any)['restrictedGroupSettings'];
    if (!settings || !settings[key] || !Array.isArray(settings[key])) return false;
    return settings[key].some((groupId: number) => this.checkIfInUserGroup(groupId));
  }

  addToInlineSearchProps(item) {

    if (environment.useInlineSearch === true && this.dfms.isFormReadOnly === true) {
      item.bindingProperty = this.getBindingPropertyName();

      if (this.searchService.splitSearchKeywords.filter(i => i.bindingProperty == item.bindingProperty).length == 0) {

        item.name = this.utility.getCurrentRoute().labels[this.getAttribute('name')];
        this.searchService.splitSearchKeywords.push(item);
        this.searchService.splitSearchEnabled = true;

        this.searchService.splitSearchS.next(undefined);
      }
    }
  }

}
